
/*
 * Wizard settings action types
 */

export const CREATE_SETTINGS = 'CREATE_SETTINGS';

// eslint-disable-next-line camelcase
export const createSettings = (postal_code_key, adyen_key, wizard_urls, recaptcha_sitekey) => ({
    type: CREATE_SETTINGS,
    postal_code_key,
    adyen_key,
    wizard_urls,
    recaptcha_sitekey
});
